import * as React           from 'react'
import { FormattedMessage } from 'react-intl'
import { connect }          from 'react-redux'

import Card       from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Table      from '@material-ui/core/Table'
import TableBody  from '@material-ui/core/TableBody'
import TableCell  from '@material-ui/core/TableCell'
import TableHead  from '@material-ui/core/TableHead'
import TableRow   from '@material-ui/core/TableRow'
import Tooltip    from '@material-ui/core/Tooltip'

import { CoachingprogramCoachPrices } from '../../api'
import { selectCurrency }             from '../../redux/ducks'

interface CoachPriceTableProps {
  coachPrices: CoachingprogramCoachPrices []
  onDelete: (index: number) => void
}

const mstp = state => ({ currency: selectCurrency(state) })

type Props =
  ReturnType<typeof mstp>
  & CoachPriceTableProps

const CoachPriceTable: React.SFC<Props> = ({
  coachPrices,
  currency,
  onDelete,
}) => {
  if (!coachPrices.length) return null

  const phrasing = {
    email:                   <FormattedMessage id={'labels.email'} />,
    price:                   <FormattedMessage id={'labels.price'} />,
    tableTitle:              <FormattedMessage id={'generic.coachPriceTableTitle'} />,
    clickPriceEntryToDelete: <FormattedMessage id={'generic.clickPriceEntryToDelete'} />,
  }

  return (
    <Card>
      <CardHeader
        subheader={phrasing.clickPriceEntryToDelete}
        title={phrasing.tableTitle}
      />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              {phrasing.email}
            </TableCell>
            <TableCell numeric>
              {phrasing.price}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {coachPrices.map(({ email, price }, i) => (
            <Tooltip
              title={
                <FormattedMessage
                  id={'generic.deleteSpecialPrice'}
                  values={{ email }}
                />
              }
            >
              <TableRow
                hover
                className={'cursor-pointer'}
                key={email}
                onClick={() => onDelete(i)}
              >
                <TableCell>
                  {email}
                </TableCell>
                <TableCell numeric>
                  {currency} {price}
                </TableCell>
              </TableRow>
            </Tooltip>
          ))}
        </TableBody>
      </Table>
    </Card>
  )
}

export default connect(mstp)(CoachPriceTable)



// WEBPACK FOOTER //
// ./src/components/molecules/CoachPriceTable.tsx